<template>

	<div v-lazyload class="imageBox" style="">
		<img ref="image" :data-url="src" :title="this.title"/>
	</div>
</template>
<script>

import LazyLoadDirective from "@/directives/LazyLoadDirective";
//import settings from "../../settings";

export default {
	name: "ProductCellImageSquare",
	directives: {
		lazyload: LazyLoadDirective
	},
	props:{
		filename:{
			type: String,
			default: null
		},
		width: {
			type: String,
			default: "200px"
		},
		maxwidth:{
			type: String,
			default: "500px"
		},
		parentTitle:String
	},
	watch: {
		filename: function (newFilename) { // byter ut bilden om den byts ut // oldFilename
			//console.log("FP: watcher: filename: ", newFilename);
			//console.log("FP: watcher: filename: ", oldFilename);
			const image = this.$refs.image;

			if(image.src && image.src != newFilename){
				image.src = newFilename
			}
			console.log("FP: watcher: filename: src: ", image.src);
		}
	},
	computed: {
		src() {

			if (this.filename == null){
				return require("@/assets/missing.jpg");
			}

			return this.filename
		},

		title(){
			if (this.debug){
				return this.parentTitle + "ProductImageSquare, filename: " + this.filename + "\n"
			}
			
			return "";
		}
	},
};
</script>

<style scoped>

.loading img {
	opacity: 0.3;
}

.loaded img {
	opacity: 1;
	transition: opacity 0.3s ease;
}

div.imageBox {
	width: v-bind("width");
	max-width: v-bind("maxwidth");
	display: flex;
	align-items: center;
	display: inline;
	/*max-height: auto;*/
	background:var(--grey-2);
	
	height:min(300px, 300px); /* FP: testar i produktlistan, kan tas bort */
	/*height:min(50%, 350px);*/
	
	/*border:1px solid lightgrey;*/

}

div img {
	width: calc(100% - 20px);
	height: calc(100% - 20px);
	margin: 0 auto;
	object-fit: contain;
	padding: 10px;

}

@media (max-width: 620px) {
	div.imageBox {
		max-height: 150px;
	}
}
</style>